'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002emath$002e$002dConversion$0024 from "./java.math.-Conversion$.js";
var $p;
/** @constructor */
function $c_Ljava_math_BigInteger$QuotAndRem(quot, rem) {
  this.hD = null;
  this.lR = null;
  this.hD = quot;
  this.lR = rem;
}
export { $c_Ljava_math_BigInteger$QuotAndRem as $c_Ljava_math_BigInteger$QuotAndRem };
$p = $c_Ljava_math_BigInteger$QuotAndRem.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_math_BigInteger$QuotAndRem;
/** @constructor */
function $h_Ljava_math_BigInteger$QuotAndRem() {
}
export { $h_Ljava_math_BigInteger$QuotAndRem as $h_Ljava_math_BigInteger$QuotAndRem };
$h_Ljava_math_BigInteger$QuotAndRem.prototype = $p;
$p.Y3 = (function() {
  return new ($d_Ljava_math_BigInteger.r().C)([this.hD, this.lR]);
});
var $d_Ljava_math_BigInteger$QuotAndRem = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_math_BigInteger$QuotAndRem, "java.math.BigInteger$QuotAndRem", ({
  kz: 1
}));
export { $d_Ljava_math_BigInteger$QuotAndRem as $d_Ljava_math_BigInteger$QuotAndRem };
/** @constructor */
function $c_Ljava_math_BitLevel$() {
}
export { $c_Ljava_math_BitLevel$ as $c_Ljava_math_BitLevel$ };
$p = $c_Ljava_math_BitLevel$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_math_BitLevel$;
/** @constructor */
function $h_Ljava_math_BitLevel$() {
}
export { $h_Ljava_math_BitLevel$ as $h_Ljava_math_BitLevel$ };
$h_Ljava_math_BitLevel$.prototype = $p;
$p.kO = (function(bi) {
  if ((bi.a3 === 0)) {
    return 0;
  } else {
    var bLength = (bi.a8 << 5);
    var highDigit = bi.Y.a[((bi.a8 - 1) | 0)];
    if ((bi.a3 < 0)) {
      if ((bi.xn() === ((bi.a8 - 1) | 0))) {
        highDigit = ((highDigit - 1) | 0);
      }
    }
    bLength = ((bLength - Math.clz32(highDigit)) | 0);
    return bLength;
  }
});
$p.Qq = (function(source, count) {
  var intCount = ((count >>> 5) | 0);
  var andCount = (31 & count);
  var offset = ((andCount !== 0) | 0);
  var resLength = ((((source.a8 + intCount) | 0) + offset) | 0);
  $m_Ljava_math_BigInteger$().SH(resLength);
  var resDigits = new $j_java$002elang$002e$002dObject.$ac_I(resLength);
  this.Cu(resDigits, source.Y, intCount, andCount);
  var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), source.a3, resLength, resDigits);
  result.eS();
  return result;
});
$p.Cu = (function(result, source, intCount, count) {
  if ((count === 0)) {
    var x4 = ((result.a.length - intCount) | 0);
    source.K(0, result, intCount, x4);
  } else {
    var rightShiftCount = ((32 - count) | 0);
    result.a[((result.a.length - 1) | 0)] = 0;
    var i = ((result.a.length - 1) | 0);
    while ((i > intCount)) {
      var ev$1 = i;
      result.a[ev$1] = (result.a[ev$1] | ((source.a[((((i - intCount) | 0) - 1) | 0)] >>> rightShiftCount) | 0));
      result.a[((i - 1) | 0)] = (source.a[((((i - intCount) | 0) - 1) | 0)] << count);
      i = ((i - 1) | 0);
    }
  }
  var i$1 = 0;
  while ((i$1 < intCount)) {
    var value = i$1;
    result.a[value] = 0;
    i$1 = ((1 + i$1) | 0);
  }
});
$p.XB = (function(source) {
  var srcLen = source.a8;
  var resLen = ((1 + srcLen) | 0);
  var resDigits = new $j_java$002elang$002e$002dObject.$ac_I(resLen);
  this.Qr(resDigits, source.Y, srcLen);
  var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), source.a3, resLen, resDigits);
  result.eS();
  return result;
});
$p.Qr = (function(result, source, srcLen) {
  var elem = 0;
  elem = 0;
  var i = 0;
  while ((i < srcLen)) {
    var value = i;
    var iVal = source.a[value];
    result.a[value] = ((iVal << 1) | elem);
    elem = ((iVal >>> 31) | 0);
    i = ((1 + i) | 0);
  }
  if ((elem !== 0)) {
    result.a[srcLen] = elem;
  }
});
$p.Qs = (function(source, count) {
  var intCount = ((count >>> 5) | 0);
  var andCount = (31 & count);
  if ((intCount >= source.a8)) {
    return ((source.a3 < 0) ? $m_Ljava_math_BigInteger$().vi : $m_Ljava_math_BigInteger$().g7);
  } else {
    var resLength = ((source.a8 - intCount) | 0);
    var resDigits = new $j_java$002elang$002e$002dObject.$ac_I(((1 + resLength) | 0));
    this.Qt(resDigits, resLength, source.Y, intCount, andCount);
    if ((source.a3 < 0)) {
      var i = 0;
      while (((i < intCount) && (source.Y.a[i] === 0))) {
        i = ((1 + i) | 0);
      }
      var cmp = ((source.Y.a[i] << ((-andCount) | 0)) !== 0);
      if (((i < intCount) || ((andCount > 0) && cmp))) {
        i = 0;
        while (((i < resLength) && (resDigits.a[i] === (-1)))) {
          resDigits.a[i] = 0;
          i = ((1 + i) | 0);
        }
        if ((i === resLength)) {
          resLength = ((1 + resLength) | 0);
        }
        var ev$1 = i;
        resDigits.a[ev$1] = ((1 + resDigits.a[ev$1]) | 0);
      }
    }
    var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), source.a3, resLength, resDigits);
    result.eS();
    return result;
  }
});
$p.Qt = (function(result, resultLen, source, intCount, count) {
  var i = 0;
  var allZero = true;
  while ((i < intCount)) {
    allZero = (!(!(allZero & (source.a[i] === 0))));
    i = ((1 + i) | 0);
  }
  if ((count === 0)) {
    source.K(intCount, result, 0, resultLen);
  } else {
    var leftShiftCount = ((32 - count) | 0);
    allZero = (!(!(allZero & ((source.a[i] << leftShiftCount) === 0))));
    i = 0;
    while ((i < ((resultLen - 1) | 0))) {
      result.a[i] = (((source.a[((i + intCount) | 0)] >>> count) | 0) | (source.a[((1 + ((i + intCount) | 0)) | 0)] << leftShiftCount));
      i = ((1 + i) | 0);
    }
    result.a[i] = ((source.a[((i + intCount) | 0)] >>> count) | 0);
    i = ((1 + i) | 0);
  }
  return allZero;
});
var $d_Ljava_math_BitLevel$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_math_BitLevel$, "java.math.BitLevel$", ({
  kA: 1
}));
export { $d_Ljava_math_BitLevel$ as $d_Ljava_math_BitLevel$ };
var $n_Ljava_math_BitLevel$;
function $m_Ljava_math_BitLevel$() {
  if ((!$n_Ljava_math_BitLevel$)) {
    $n_Ljava_math_BitLevel$ = new $c_Ljava_math_BitLevel$();
  }
  return $n_Ljava_math_BitLevel$;
}
export { $m_Ljava_math_BitLevel$ as $m_Ljava_math_BitLevel$ };
/** @constructor */
function $c_Ljava_math_Division$() {
}
export { $c_Ljava_math_Division$ as $c_Ljava_math_Division$ };
$p = $c_Ljava_math_Division$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_math_Division$;
/** @constructor */
function $h_Ljava_math_Division$() {
}
export { $h_Ljava_math_Division$ as $h_Ljava_math_Division$ };
$h_Ljava_math_Division$.prototype = $p;
$p.OI = (function(quot, quotLength, a, aLength, b, bLength) {
  var normA = new $j_java$002elang$002e$002dObject.$ac_I(((1 + aLength) | 0));
  var normB = new $j_java$002elang$002e$002dObject.$ac_I(((1 + bLength) | 0));
  var i = b.a[((bLength - 1) | 0)];
  var divisorShift = Math.clz32(i);
  if ((divisorShift !== 0)) {
    $m_Ljava_math_BitLevel$().Cu(normB, b, 0, divisorShift);
    $m_Ljava_math_BitLevel$().Cu(normA, a, 0, divisorShift);
  } else {
    a.K(0, normA, 0, aLength);
    b.K(0, normB, 0, bLength);
  }
  var firstDivisorDigit = normB.a[((bLength - 1) | 0)];
  var i$1 = ((quotLength - 1) | 0);
  var elem = 0;
  elem = aLength;
  while ((i$1 >= 0)) {
    var elem$1 = 0;
    elem$1 = 0;
    if ((normA.a[elem] === firstDivisorDigit)) {
      elem$1 = (-1);
    } else {
      var value = normA.a[elem];
      var value$1 = normA.a[((elem - 1) | 0)];
      var $x_1 = $j_java$002elang$002e$002dObject.$m_RTLong$().Bm(value$1, value, firstDivisorDigit, 0);
      var quotient_$_lo = $x_1.l;
      var quotient_$_hi = $x_1.h;
      elem$1 = quotient_$_lo;
      var a0 = (65535 & quotient_$_lo);
      var a1 = ((quotient_$_lo >>> 16) | 0);
      var b0 = (65535 & firstDivisorDigit);
      var b1 = ((firstDivisorDigit >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var lo$1 = ((value$1 - lo) | 0);
      var elem$2 = 0;
      elem$2 = lo$1;
      if ((elem$1 !== 0)) {
        elem$1 = ((1 + elem$1) | 0);
        while (true) {
          elem$1 = ((elem$1 - 1) | 0);
          var value$2 = elem$1;
          var value$3 = normB.a[((bLength - 2) | 0)];
          var a0$1 = (65535 & value$2);
          var a1$1 = ((value$2 >>> 16) | 0);
          var b0$1 = (65535 & value$3);
          var b1$1 = ((value$3 >>> 16) | 0);
          var a0b0$1 = Math.imul(a0$1, b0$1);
          var a1b0$1 = Math.imul(a1$1, b0$1);
          var a0b1$1 = Math.imul(a0$1, b1$1);
          var lo$2 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
          var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
          var hi$7 = ((((Math.imul(a1$1, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
          var value$4 = elem$2;
          var value$5 = normA.a[((elem - 2) | 0)];
          var value$6 = elem$2;
          var lo$3 = ((value$6 + firstDivisorDigit) | 0);
          if (((((lo$3 >>> 0) < (value$6 >>> 0)) | 0) === 0)) {
            elem$2 = lo$3;
            if (((hi$7 === value$4) ? ((lo$2 >>> 0) > (value$5 >>> 0)) : ((hi$7 >>> 0) > (value$4 >>> 0)))) {
              continue;
            }
          }
          break;
        }
      }
    }
    if ((elem$1 !== 0)) {
      if (($m_Ljava_math_Division$().Wa(normA, ((elem - bLength) | 0), normB, bLength, elem$1) !== 0)) {
        elem$1 = ((elem$1 - 1) | 0);
        var elem$3_$_lo = 0;
        var elem$3_$_hi = 0;
        elem$3_$_lo = 0;
        elem$3_$_hi = 0;
        var i$2 = 0;
        while ((i$2 < bLength)) {
          var value$7 = i$2;
          var x_$_lo = elem$3_$_lo;
          var x_$_hi = elem$3_$_hi;
          var value$8 = normA.a[((((elem - bLength) | 0) + value$7) | 0)];
          var value$9 = normB.a[value$7];
          var lo$4 = ((value$8 + value$9) | 0);
          var hi$15 = (((lo$4 >>> 0) < (value$8 >>> 0)) | 0);
          var lo$5 = ((x_$_lo + lo$4) | 0);
          var hi$16 = ((((x_$_hi + hi$15) | 0) + (((lo$5 >>> 0) < (x_$_lo >>> 0)) | 0)) | 0);
          elem$3_$_lo = lo$5;
          elem$3_$_hi = hi$16;
          normA.a[((((elem - bLength) | 0) + value$7) | 0)] = elem$3_$_lo;
          var x$2_$_lo = elem$3_$_lo;
          var x$2_$_hi = elem$3_$_hi;
          elem$3_$_lo = x$2_$_hi;
          elem$3_$_hi = 0;
          i$2 = ((1 + i$2) | 0);
        }
      }
    }
    if ((quot !== null)) {
      quot.a[i$1] = elem$1;
    }
    elem = ((elem - 1) | 0);
    i$1 = ((i$1 - 1) | 0);
  }
  if ((divisorShift !== 0)) {
    $m_Ljava_math_BitLevel$().Qt(normB, bLength, normA, 0, divisorShift);
    return normB;
  } else {
    normA.K(0, normB, 0, bLength);
    return normA;
  }
});
$p.TD = (function(bi, divisor, divisorSign) {
  var valDigits = bi.Y;
  var valLen = bi.a8;
  var valSign = bi.a3;
  if ((valLen === 1)) {
    var valDigit = valDigits.a[0];
    var value = (((valDigit >>> 0) / ($j_java$002elang$002e$002dObject.$checkIntDivisor(divisor) >>> 0)) | 0);
    var quo_$_lo = value;
    var quo_$_hi = 0;
    var value$1 = (((valDigit >>> 0) % ($j_java$002elang$002e$002dObject.$checkIntDivisor(divisor) >>> 0)) | 0);
    var rem_$_lo = value$1;
    var rem_$_hi = 0;
    if ((valSign !== divisorSign)) {
      var x_$_lo = quo_$_lo;
      var x_$_hi = quo_$_hi;
      var lo = ((-x_$_lo) | 0);
      var hi$2 = ((((-x_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
      quo_$_lo = lo;
      quo_$_hi = hi$2;
    }
    if ((valSign < 0)) {
      var x$1_$_lo = rem_$_lo;
      var x$1_$_hi = rem_$_hi;
      var lo$1 = ((-x$1_$_lo) | 0);
      var hi$3 = ((((-x$1_$_hi) | 0) - ((lo$1 !== 0) | 0)) | 0);
      rem_$_lo = lo$1;
      rem_$_hi = hi$3;
    }
    return new $c_Ljava_math_BigInteger$QuotAndRem($m_Ljava_math_BigInteger$().ed(quo_$_lo, quo_$_hi), $m_Ljava_math_BigInteger$().ed(rem_$_lo, rem_$_hi));
  } else {
    var quotientSign = ((valSign === divisorSign) ? 1 : (-1));
    var quotientDigits = new $j_java$002elang$002e$002dObject.$ac_I(valLen);
    var div = this.OJ(quotientDigits, valDigits, valLen, divisor);
    var remainderDigits = new $j_java$002elang$002e$002dObject.$ac_I(new Int32Array([div]));
    var result0 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), quotientSign, valLen, quotientDigits);
    var result1 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), valSign, 1, remainderDigits);
    result0.eS();
    result1.eS();
    return new $c_Ljava_math_BigInteger$QuotAndRem(result0, result1);
  }
});
$p.OJ = (function(dest, src, srcLength, divisor) {
  var rem = 0;
  var i = ((srcLength - 1) | 0);
  while ((i >= 0)) {
    var value = rem;
    var value$1 = src.a[i];
    var $x_1 = $j_java$002elang$002e$002dObject.$m_RTLong$().Bm(value$1, value, divisor, 0);
    var quot_$_lo = $x_1.l;
    var quot_$_hi = $x_1.h;
    var a0 = (65535 & quot_$_lo);
    var a1 = ((quot_$_lo >>> 16) | 0);
    var b0 = (65535 & divisor);
    rem = ((value$1 - ((Math.imul(a0, b0) + (((Math.imul(a1, b0) + Math.imul(a0, ((divisor >>> 16) | 0))) | 0) << 16)) | 0)) | 0);
    dest.a[i] = quot_$_lo;
    i = ((i - 1) | 0);
  }
  return rem;
});
$p.Wa = (function(a, start, b, bLen, c) {
  var elem = 0;
  elem = 0;
  var elem$1 = 0;
  elem$1 = 0;
  var i = 0;
  while ((i < bLen)) {
    var value = i;
    $m_Ljava_math_Multiplication$();
    var a$1 = b.a[value];
    var c$1 = elem;
    var a0 = (65535 & a$1);
    var a1 = ((a$1 >>> 16) | 0);
    var b0 = (65535 & c);
    var b1 = ((c >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$1 = ((lo + c$1) | 0);
    var hi$4 = ((hi$2 + (((lo$1 >>> 0) < (lo >>> 0)) | 0)) | 0);
    var value$1 = a.a[((start + value) | 0)];
    var lo$2 = ((value$1 - lo$1) | 0);
    var hi$6 = ((-(((lo$2 >>> 0) > (value$1 >>> 0)) | 0)) | 0);
    var value$2 = elem$1;
    var hi$7 = (value$2 >> 31);
    var lo$3 = ((lo$2 + value$2) | 0);
    var hi$8 = ((((hi$6 + hi$7) | 0) + (((lo$3 >>> 0) < (lo$2 >>> 0)) | 0)) | 0);
    a.a[((start + value) | 0)] = lo$3;
    elem$1 = hi$8;
    elem = hi$4;
    i = ((1 + i) | 0);
  }
  var value$3 = a.a[((start + bLen) | 0)];
  var value$4 = elem;
  var lo$4 = ((value$3 - value$4) | 0);
  var hi$13 = ((-(((lo$4 >>> 0) > (value$3 >>> 0)) | 0)) | 0);
  var value$5 = elem$1;
  var hi$14 = (value$5 >> 31);
  var lo$5 = ((lo$4 + value$5) | 0);
  var hi$15 = ((((hi$13 + hi$14) | 0) + (((lo$5 >>> 0) < (lo$4 >>> 0)) | 0)) | 0);
  a.a[((start + bLen) | 0)] = lo$5;
  return hi$15;
});
var $d_Ljava_math_Division$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_math_Division$, "java.math.Division$", ({
  kC: 1
}));
export { $d_Ljava_math_Division$ as $d_Ljava_math_Division$ };
var $n_Ljava_math_Division$;
function $m_Ljava_math_Division$() {
  if ((!$n_Ljava_math_Division$)) {
    $n_Ljava_math_Division$ = new $c_Ljava_math_Division$();
  }
  return $n_Ljava_math_Division$;
}
export { $m_Ljava_math_Division$ as $m_Ljava_math_Division$ };
function $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI($thiz, a, aSize, b, bSize) {
  var res = new $j_java$002elang$002e$002dObject.$ac_I(((1 + aSize) | 0));
  $p_Ljava_math_Elementary$__add__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize);
  return res;
}
export { $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI as $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI };
function $p_Ljava_math_Elementary$__add__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize) {
  var i = 1;
  var value = a.a[0];
  var value$1 = b.a[0];
  var lo = ((value + value$1) | 0);
  var hi$2 = (((lo >>> 0) < (value >>> 0)) | 0);
  res.a[0] = lo;
  var carry = hi$2;
  if ((aSize >= bSize)) {
    while ((i < bSize)) {
      var value$2 = a.a[i];
      var value$3 = b.a[i];
      var lo$1 = ((value$2 + value$3) | 0);
      var hi$6 = (((lo$1 >>> 0) < (value$2 >>> 0)) | 0);
      var value$4 = carry;
      var lo$2 = ((lo$1 + value$4) | 0);
      var hi$8 = ((hi$6 + (((lo$2 >>> 0) < (lo$1 >>> 0)) | 0)) | 0);
      res.a[i] = lo$2;
      carry = hi$8;
      i = ((1 + i) | 0);
    }
    while ((i < aSize)) {
      var value$5 = a.a[i];
      var value$6 = carry;
      var lo$3 = ((value$5 + value$6) | 0);
      var hi$12 = (((lo$3 >>> 0) < (value$5 >>> 0)) | 0);
      res.a[i] = lo$3;
      carry = hi$12;
      i = ((1 + i) | 0);
    }
  } else {
    while ((i < aSize)) {
      var value$7 = a.a[i];
      var value$8 = b.a[i];
      var lo$4 = ((value$7 + value$8) | 0);
      var hi$16 = (((lo$4 >>> 0) < (value$7 >>> 0)) | 0);
      var value$9 = carry;
      var lo$5 = ((lo$4 + value$9) | 0);
      var hi$18 = ((hi$16 + (((lo$5 >>> 0) < (lo$4 >>> 0)) | 0)) | 0);
      res.a[i] = lo$5;
      carry = hi$18;
      i = ((1 + i) | 0);
    }
    while ((i < bSize)) {
      var value$10 = b.a[i];
      var value$11 = carry;
      var lo$6 = ((value$10 + value$11) | 0);
      var hi$22 = (((lo$6 >>> 0) < (value$10 >>> 0)) | 0);
      res.a[i] = lo$6;
      carry = hi$22;
      i = ((1 + i) | 0);
    }
  }
  if ((carry !== 0)) {
    res.a[i] = carry;
  }
}
export { $p_Ljava_math_Elementary$__add__AI__AI__I__AI__I__V as $p_Ljava_math_Elementary$__add__AI__AI__I__AI__I__V };
function $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI($thiz, a, aSize, b, bSize) {
  var res = new $j_java$002elang$002e$002dObject.$ac_I(aSize);
  $p_Ljava_math_Elementary$__subtract__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize);
  return res;
}
export { $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI as $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI };
function $p_Ljava_math_Elementary$__subtract__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize) {
  var i = 0;
  var borrow = 0;
  while ((i < bSize)) {
    var value = a.a[i];
    var value$1 = b.a[i];
    var lo = ((value - value$1) | 0);
    var hi$2 = ((-(((lo >>> 0) > (value >>> 0)) | 0)) | 0);
    var value$2 = borrow;
    var hi$3 = (value$2 >> 31);
    var lo$1 = ((lo + value$2) | 0);
    var hi$4 = ((((hi$2 + hi$3) | 0) + (((lo$1 >>> 0) < (lo >>> 0)) | 0)) | 0);
    res.a[i] = lo$1;
    borrow = hi$4;
    i = ((1 + i) | 0);
  }
  while ((i < aSize)) {
    var value$3 = a.a[i];
    var value$4 = borrow;
    var hi$7 = (value$4 >> 31);
    var lo$2 = ((value$3 + value$4) | 0);
    var hi$8 = ((hi$7 + (((lo$2 >>> 0) < (value$3 >>> 0)) | 0)) | 0);
    res.a[i] = lo$2;
    borrow = hi$8;
    i = ((1 + i) | 0);
  }
}
export { $p_Ljava_math_Elementary$__subtract__AI__AI__I__AI__I__V as $p_Ljava_math_Elementary$__subtract__AI__AI__I__AI__I__V };
/** @constructor */
function $c_Ljava_math_Elementary$() {
}
export { $c_Ljava_math_Elementary$ as $c_Ljava_math_Elementary$ };
$p = $c_Ljava_math_Elementary$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_math_Elementary$;
/** @constructor */
function $h_Ljava_math_Elementary$() {
}
export { $h_Ljava_math_Elementary$ as $h_Ljava_math_Elementary$ };
$h_Ljava_math_Elementary$.prototype = $p;
$p.ji = (function(op1, op2) {
  var op1Sign = op1.a3;
  var op2Sign = op2.a3;
  var op1Len = op1.a8;
  var op2Len = op2.a8;
  if ((op1Sign === 0)) {
    return op2;
  } else if ((op2Sign === 0)) {
    return op1;
  } else if ((((op1Len + op2Len) | 0) === 2)) {
    var value = op1.Y.a[0];
    var value$1 = op2.Y.a[0];
    if ((op1Sign === op2Sign)) {
      var lo = ((value + value$1) | 0);
      var hi$2 = (((lo >>> 0) < (value >>> 0)) | 0);
      return ((hi$2 === 0) ? $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), op1Sign, lo) : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), op1Sign, 2, new $j_java$002elang$002e$002dObject.$ac_I(new Int32Array([lo, hi$2]))));
    } else {
      var $x_2 = $m_Ljava_math_BigInteger$();
      if ((op1Sign < 0)) {
        var lo$1 = ((value$1 - value) | 0);
        var hi$3 = ((-(((lo$1 >>> 0) > (value$1 >>> 0)) | 0)) | 0);
        var $x_1_$_lo = lo$1;
        var $x_1_$_hi = hi$3;
      } else {
        var lo$2 = ((value - value$1) | 0);
        var hi$4 = ((-(((lo$2 >>> 0) > (value >>> 0)) | 0)) | 0);
        var $x_1_$_lo = lo$2;
        var $x_1_$_hi = hi$4;
      }
      return $x_2.ed($x_1_$_lo, $x_1_$_hi);
    }
  } else {
    if ((op1Sign === op2Sign)) {
      var x1___1 = op1Sign;
      var x1___2 = ((op1Len >= op2Len) ? $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, op1.Y, op1Len, op2.Y, op2Len) : $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, op2.Y, op2Len, op1.Y, op1Len));
    } else {
      var cmp = ((op1Len !== op2Len) ? ((op1Len > op2Len) ? 1 : (-1)) : this.u3(op1.Y, op2.Y, op1Len));
      if ((cmp === 0)) {
        return $m_Ljava_math_BigInteger$().g7;
      }
      if ((cmp === 1)) {
        var x1___1 = op1Sign;
        var x1___2 = $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, op1.Y, op1Len, op2.Y, op2Len);
      } else {
        var x1___1 = op2Sign;
        var x1___2 = $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, op2.Y, op2Len, op1.Y, op1Len);
      }
    }
    var resSign = (x1___1 | 0);
    var resDigits = x1___2;
    var res$3 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resDigits.a.length, resDigits);
    res$3.eS();
    return res$3;
  }
});
$p.u3 = (function(a, b, size) {
  var i = ((size - 1) | 0);
  while (((i >= 0) && (a.a[i] === b.a[i]))) {
    i = ((i - 1) | 0);
  }
  return ((i < 0) ? 0 : (((a.a[i] >>> 0) < (b.a[i] >>> 0)) ? (-1) : 1));
});
$p.Vf = (function(a, aSize, addend) {
  var carry = addend;
  var i = 0;
  while (((carry !== 0) && (i < aSize))) {
    var value = carry;
    var value$1 = a.a[i];
    var lo = ((value + value$1) | 0);
    var hi$2 = (((lo >>> 0) < (value >>> 0)) | 0);
    a.a[i] = lo;
    carry = hi$2;
    i = ((1 + i) | 0);
  }
  return carry;
});
$p.lg = (function(op1, op2) {
  var op1Sign = op1.a3;
  var op2Sign = op2.a3;
  var op1Len = op1.a8;
  var op2Len = op2.a8;
  if ((op2Sign === 0)) {
    return op1;
  } else if ((op1Sign === 0)) {
    return op2.xI();
  } else if ((((op1Len + op2Len) | 0) === 2)) {
    var value = op1.Y.a[0];
    var a_$_lo = value;
    var a_$_hi = 0;
    var value$1 = op2.Y.a[0];
    var b_$_lo = value$1;
    var b_$_hi = 0;
    if ((op1Sign < 0)) {
      var x_$_lo = a_$_lo;
      var x_$_hi = a_$_hi;
      var lo = ((-x_$_lo) | 0);
      var hi$2 = ((((-x_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
      a_$_lo = lo;
      a_$_hi = hi$2;
    }
    if ((op2Sign < 0)) {
      var x$1_$_lo = b_$_lo;
      var x$1_$_hi = b_$_hi;
      var lo$1 = ((-x$1_$_lo) | 0);
      var hi$3 = ((((-x$1_$_hi) | 0) - ((lo$1 !== 0) | 0)) | 0);
      b_$_lo = lo$1;
      b_$_hi = hi$3;
    }
    var $x_1 = $m_Ljava_math_BigInteger$();
    var x$2_$_lo = a_$_lo;
    var x$2_$_hi = a_$_hi;
    var x$3_$_lo = b_$_lo;
    var x$3_$_hi = b_$_hi;
    var lo$2 = ((x$2_$_lo - x$3_$_lo) | 0);
    var hi$4 = ((((x$2_$_hi - x$3_$_hi) | 0) - (((lo$2 >>> 0) > (x$2_$_lo >>> 0)) | 0)) | 0);
    return $x_1.ed(lo$2, hi$4);
  } else {
    var cmp = ((op1Len !== op2Len) ? ((op1Len > op2Len) ? 1 : (-1)) : $m_Ljava_math_Elementary$().u3(op1.Y, op2.Y, op1Len));
    if ((((op1Sign ^ op2Sign) | cmp) === 0)) {
      return $m_Ljava_math_BigInteger$().g7;
    }
    if ((cmp === (-1))) {
      var x1___1 = ((-op2Sign) | 0);
      var x1___2 = ((op1Sign === op2Sign) ? $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, op2.Y, op2Len, op1.Y, op1Len) : $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, op2.Y, op2Len, op1.Y, op1Len));
    } else if ((op1Sign === op2Sign)) {
      var x1___1 = op1Sign;
      var x1___2 = $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, op1.Y, op1Len, op2.Y, op2Len);
    } else {
      var x1___1 = op1Sign;
      var x1___2 = $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, op1.Y, op1Len, op2.Y, op2Len);
    }
    var resSign = (x1___1 | 0);
    var resDigits = x1___2;
    var res$2 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resDigits.a.length, resDigits);
    res$2.eS();
    return res$2;
  }
});
var $d_Ljava_math_Elementary$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_math_Elementary$, "java.math.Elementary$", ({
  kD: 1
}));
export { $d_Ljava_math_Elementary$ as $d_Ljava_math_Elementary$ };
var $n_Ljava_math_Elementary$;
function $m_Ljava_math_Elementary$() {
  if ((!$n_Ljava_math_Elementary$)) {
    $n_Ljava_math_Elementary$ = new $c_Ljava_math_Elementary$();
  }
  return $n_Ljava_math_Elementary$;
}
export { $m_Ljava_math_Elementary$ as $m_Ljava_math_Elementary$ };
function $p_Ljava_math_Multiplication$__initialiseArrays__V($thiz) {
  var elem_$_lo = 0;
  var elem_$_hi = 0;
  elem_$_lo = 1;
  elem_$_hi = 0;
  var i = 0;
  while ((i < 32)) {
    var value = i;
    if ((value <= 18)) {
      $m_Ljava_math_Multiplication$().iI.a[value] = $m_Ljava_math_BigInteger$().ed(elem_$_lo, elem_$_hi);
      var $x_2 = $m_Ljava_math_Multiplication$().iJ;
      var $x_1 = $m_Ljava_math_BigInteger$();
      var x_$_lo = elem_$_lo;
      var x_$_hi = elem_$_hi;
      var lo = (((32 & value) === 0) ? (x_$_lo << value) : 0);
      var hi = (((32 & value) === 0) ? (((((x_$_lo >>> 1) | 0) >>> (~value)) | 0) | (x_$_hi << value)) : (x_$_lo << value));
      $x_2.a[value] = $x_1.ed(lo, hi);
      var x$1_$_lo = elem_$_lo;
      var x$1_$_hi = elem_$_hi;
      var b0 = (65535 & x$1_$_lo);
      var b1 = ((x$1_$_lo >>> 16) | 0);
      var a0b0 = Math.imul(5, b0);
      var a0b1 = Math.imul(5, b1);
      var lo$1 = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$1 = ((Math.imul(5, x$1_$_hi) + ((c1part >>> 16) | 0)) | 0);
      elem_$_lo = lo$1;
      elem_$_hi = hi$1;
    } else {
      $m_Ljava_math_Multiplication$().iI.a[value] = $m_Ljava_math_Multiplication$().iI.a[((value - 1) | 0)].dv($m_Ljava_math_Multiplication$().iI.a[1]);
      $m_Ljava_math_Multiplication$().iJ.a[value] = $m_Ljava_math_Multiplication$().iJ.a[((value - 1) | 0)].dv($m_Ljava_math_BigInteger$().gP);
    }
    i = ((1 + i) | 0);
  }
}
export { $p_Ljava_math_Multiplication$__initialiseArrays__V as $p_Ljava_math_Multiplication$__initialiseArrays__V };
function $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I($thiz, res, a, aSize, factor) {
  var elem = 0;
  elem = 0;
  var i = 0;
  while ((i < aSize)) {
    var value = i;
    $m_Ljava_math_Multiplication$();
    var a$1 = a.a[value];
    var c = elem;
    var a0 = (65535 & a$1);
    var a1 = ((a$1 >>> 16) | 0);
    var b0 = (65535 & factor);
    var b1 = ((factor >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$1 = ((lo + c) | 0);
    var hi$4 = ((hi$2 + (((lo$1 >>> 0) < (lo >>> 0)) | 0)) | 0);
    res.a[value] = lo$1;
    elem = hi$4;
    i = ((1 + i) | 0);
  }
  return elem;
}
export { $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I as $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I };
function $p_Ljava_math_Multiplication$__multPAP__AI__AI__AI__I__I__V($thiz, a, b, t, aLen, bLen) {
  if (((a === b) && (aLen === bLen))) {
    $thiz.QB(a, aLen, t);
  } else {
    var i = 0;
    while ((i < aLen)) {
      var value = i;
      var elem = 0;
      elem = 0;
      var aI = a.a[value];
      var i$1 = 0;
      while ((i$1 < bLen)) {
        var value$1 = i$1;
        $m_Ljava_math_Multiplication$();
        var b$1 = b.a[value$1];
        var c = t.a[((value + value$1) | 0)];
        var d = elem;
        var a0 = (65535 & aI);
        var a1 = ((aI >>> 16) | 0);
        var b0 = (65535 & b$1);
        var b1 = ((b$1 >>> 16) | 0);
        var a0b0 = Math.imul(a0, b0);
        var a1b0 = Math.imul(a1, b0);
        var a0b1 = Math.imul(a0, b1);
        var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        var lo$1 = ((lo + c) | 0);
        var hi$4 = ((hi$2 + (((lo$1 >>> 0) < (lo >>> 0)) | 0)) | 0);
        var lo$2 = ((lo$1 + d) | 0);
        var hi$6 = ((hi$4 + (((lo$2 >>> 0) < (lo$1 >>> 0)) | 0)) | 0);
        t.a[((value + value$1) | 0)] = lo$2;
        elem = hi$6;
        i$1 = ((1 + i$1) | 0);
      }
      t.a[((value + bLen) | 0)] = elem;
      i = ((1 + i) | 0);
    }
  }
}
export { $p_Ljava_math_Multiplication$__multPAP__AI__AI__AI__I__I__V as $p_Ljava_math_Multiplication$__multPAP__AI__AI__AI__I__I__V };
function $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI($thiz, len, pow) {
  var result = new $j_java$002elang$002e$002dObject.$ac_I(len);
  result.a[0] = 1;
  var i = 1;
  while ((i < len)) {
    var value = i;
    result.a[value] = Math.imul(result.a[((value - 1) | 0)], pow);
    i = ((1 + i) | 0);
  }
  return result;
}
export { $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI as $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI };
/** @constructor */
function $c_Ljava_math_Multiplication$() {
  this.zJ = null;
  this.iJ = null;
  this.iI = null;
  $n_Ljava_math_Multiplication$ = this;
  this.zJ = $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI(this, 10, 10);
  $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI(this, 14, 5);
  this.iJ = new ($d_Ljava_math_BigInteger.r().C)(32);
  this.iI = new ($d_Ljava_math_BigInteger.r().C)(32);
  $p_Ljava_math_Multiplication$__initialiseArrays__V(this);
}
export { $c_Ljava_math_Multiplication$ as $c_Ljava_math_Multiplication$ };
$p = $c_Ljava_math_Multiplication$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_math_Multiplication$;
/** @constructor */
function $h_Ljava_math_Multiplication$() {
}
export { $h_Ljava_math_Multiplication$ as $h_Ljava_math_Multiplication$ };
$h_Ljava_math_Multiplication$.prototype = $p;
$p.Wb = (function(bi, factor) {
  var resSign = bi.a3;
  var aNumberLength = bi.a8;
  var aDigits = bi.Y;
  if ((resSign === 0)) {
    return $m_Ljava_math_BigInteger$().g7;
  } else if ((aNumberLength === 1)) {
    var a = aDigits.a[0];
    var a0 = (65535 & a);
    var a1 = ((a >>> 16) | 0);
    var b0 = (65535 & factor);
    var b1 = ((factor >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    return ((hi$2 === 0) ? $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), resSign, lo) : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, 2, new $j_java$002elang$002e$002dObject.$ac_I(new Int32Array([lo, hi$2]))));
  } else {
    var resLength = ((1 + aNumberLength) | 0);
    var resDigits = new $j_java$002elang$002e$002dObject.$ac_I(resLength);
    resDigits.a[aNumberLength] = $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this, resDigits, aDigits, aNumberLength, factor);
    var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resLength, resDigits);
    result.eS();
    return result;
  }
});
$p.l4 = (function(bi, exp_$_lo, exp_$_hi) {
  var value = this.zJ.a.length;
  var hi = (value >> 31);
  if (((exp_$_hi === hi) ? ((exp_$_lo >>> 0) < (value >>> 0)) : (exp_$_hi < hi))) {
    return this.Wb(bi, this.zJ.a[exp_$_lo]);
  } else {
    return bi.dv(this.rf(exp_$_lo, exp_$_hi));
  }
});
$p.QB = (function(a, aLen, res) {
  var elem = 0;
  elem = 0;
  var i = 0;
  while ((i < aLen)) {
    var value = i;
    elem = 0;
    var _\uff3fself = ((1 + value) | 0);
    var i$1 = _\uff3fself;
    while ((i$1 < aLen)) {
      var value$1 = i$1;
      $m_Ljava_math_Multiplication$();
      var a$1 = a.a[value];
      var b = a.a[value$1];
      var c = res.a[((value + value$1) | 0)];
      var d = elem;
      var a0 = (65535 & a$1);
      var a1 = ((a$1 >>> 16) | 0);
      var b0 = (65535 & b);
      var b1 = ((b >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var lo$1 = ((lo + c) | 0);
      var hi$4 = ((hi$2 + (((lo$1 >>> 0) < (lo >>> 0)) | 0)) | 0);
      var lo$2 = ((lo$1 + d) | 0);
      var hi$6 = ((hi$4 + (((lo$2 >>> 0) < (lo$1 >>> 0)) | 0)) | 0);
      res.a[((value + value$1) | 0)] = lo$2;
      elem = hi$6;
      i$1 = ((1 + i$1) | 0);
    }
    res.a[((value + aLen) | 0)] = elem;
    i = ((1 + i) | 0);
  }
  $m_Ljava_math_BitLevel$().Qr(res, res, (aLen << 1));
  elem = 0;
  var i$2 = 0;
  var index = 0;
  while ((i$2 < aLen)) {
    var a$2 = a.a[i$2];
    var b$1 = a.a[i$2];
    var c$1 = res.a[index];
    var d$1 = elem;
    var a0$1 = (65535 & a$2);
    var a1$1 = ((a$2 >>> 16) | 0);
    var b0$1 = (65535 & b$1);
    var b1$1 = ((b$1 >>> 16) | 0);
    var a0b0$1 = Math.imul(a0$1, b0$1);
    var a1b0$1 = Math.imul(a1$1, b0$1);
    var a0b1$1 = Math.imul(a0$1, b1$1);
    var lo$3 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
    var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$9 = ((((Math.imul(a1$1, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
    var lo$4 = ((lo$3 + c$1) | 0);
    var hi$11 = ((hi$9 + (((lo$4 >>> 0) < (lo$3 >>> 0)) | 0)) | 0);
    var lo$5 = ((lo$4 + d$1) | 0);
    var hi$13 = ((hi$11 + (((lo$5 >>> 0) < (lo$4 >>> 0)) | 0)) | 0);
    res.a[index] = lo$5;
    index = ((1 + index) | 0);
    var value$2 = res.a[index];
    var lo$6 = ((hi$13 + value$2) | 0);
    var hi$15 = (((lo$6 >>> 0) < (hi$13 >>> 0)) | 0);
    res.a[index] = lo$6;
    elem = hi$15;
    i$2 = ((1 + i$2) | 0);
    index = ((1 + index) | 0);
  }
  return res;
});
$p.xA = (function(val1, val2) {
  if ((val2.a8 > val1.a8)) {
    var x1___1 = val2;
    var x1___2 = val1;
  } else {
    var x1___1 = val1;
    var x1___2 = val2;
  }
  var op1 = x1___1;
  var op2 = x1___2;
  if ((op2.a8 < 63)) {
    return this.Wc(op1, op2);
  } else {
    var ndiv2 = (((-2) & op1.a8) << 4);
    var upperOp1 = op1.y9(ndiv2);
    var upperOp2 = op2.y9(ndiv2);
    var lowerOp1 = $m_Ljava_math_Elementary$().lg(op1, upperOp1.fZ(ndiv2));
    var lowerOp2 = $m_Ljava_math_Elementary$().lg(op2, upperOp2.fZ(ndiv2));
    var upper = this.xA(upperOp1, upperOp2);
    var lower = this.xA(lowerOp1, lowerOp2);
    var middle = this.xA($m_Ljava_math_Elementary$().lg(upperOp1, lowerOp1), $m_Ljava_math_Elementary$().lg(lowerOp2, upperOp2));
    middle = $m_Ljava_math_Elementary$().ji($m_Ljava_math_Elementary$().ji(middle, upper), lower);
    middle = middle.fZ(ndiv2);
    upper = upper.fZ((ndiv2 << 1));
    return $m_Ljava_math_Elementary$().ji($m_Ljava_math_Elementary$().ji(upper, middle), lower);
  }
});
$p.W8 = (function(aDigits, aLen, bDigits, bLen, resDigits) {
  if ((!((aLen === 0) || (bLen === 0)))) {
    if ((aLen === 1)) {
      resDigits.a[bLen] = $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this, resDigits, bDigits, bLen, aDigits.a[0]);
    } else if ((bLen === 1)) {
      resDigits.a[aLen] = $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this, resDigits, aDigits, aLen, bDigits.a[0]);
    } else {
      $p_Ljava_math_Multiplication$__multPAP__AI__AI__AI__I__I__V(this, aDigits, bDigits, resDigits, aLen, bLen);
    }
  }
});
$p.Wc = (function(a, b) {
  var aLen = a.a8;
  var bLen = b.a8;
  var resLength = ((aLen + bLen) | 0);
  var resSign = ((a.a3 !== b.a3) ? (-1) : 1);
  if ((resLength === 2)) {
    var a$1 = a.Y.a[0];
    var b$1 = b.Y.a[0];
    var a0 = (65535 & a$1);
    var a1 = ((a$1 >>> 16) | 0);
    var b0 = (65535 & b$1);
    var b1 = ((b$1 >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    return ((hi$2 === 0) ? $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), resSign, lo) : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, 2, new $j_java$002elang$002e$002dObject.$ac_I(new Int32Array([lo, hi$2]))));
  } else {
    var aDigits = a.Y;
    var bDigits = b.Y;
    var resDigits = new $j_java$002elang$002e$002dObject.$ac_I(resLength);
    this.W8(aDigits, aLen, bDigits, bLen, resDigits);
    var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resLength, resDigits);
    result.eS();
    return result;
  }
});
$p.WF = (function(base, exponent) {
  var exp = exponent;
  var res = $m_Ljava_math_BigInteger$().lQ;
  var acc = base;
  while ((exp > 1)) {
    var res2 = (((1 & exp) !== 0) ? res.dv(acc) : res);
    if ((acc.a8 === 1)) {
      var acc2 = acc.dv(acc);
    } else {
      var a = new $j_java$002elang$002e$002dObject.$ac_I((acc.a8 << 1));
      var acc2 = $ct_Ljava_math_BigInteger__I__AI__(new $c_Ljava_math_BigInteger(), 1, this.QB(acc.Y, acc.a8, a));
    }
    var temp$exp = (exp >> 1);
    exp = temp$exp;
    res = res2;
    acc = acc2;
  }
  return res.dv(acc);
});
$p.rf = (function(exp_$_lo, exp_$_hi) {
  var value = this.iJ.a.length;
  var hi = (value >> 31);
  if (((exp_$_hi === hi) ? ((exp_$_lo >>> 0) < (value >>> 0)) : (exp_$_hi < hi))) {
    return this.iJ.a[exp_$_lo];
  } else if (((exp_$_hi === 0) ? ((exp_$_lo >>> 0) <= 50) : (exp_$_hi < 0))) {
    return $m_Ljava_math_BigInteger$().gP.iu(exp_$_lo);
  } else if (((exp_$_hi === 0) ? ((exp_$_lo >>> 0) <= 2147483647) : (exp_$_hi < 0))) {
    return this.iI.a[1].iu(exp_$_lo).fZ(exp_$_lo);
  } else {
    var powerOfFive = this.iI.a[1].iu(2147483647);
    var res = powerOfFive;
    var lo = ((exp_$_lo - 2147483647) | 0);
    var hi$1 = ((((exp_$_hi - 1) | 0) + (((lo >>> 0) < 2147483649) | 0)) | 0);
    var longExp_$_lo = lo;
    var longExp_$_hi = hi$1;
    var sign = (exp_$_hi >> 31);
    var xlo = (exp_$_lo ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((exp_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
    var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
    var x = (4.656612875245805E-10 * aHat);
    var lo$1 = (x | 0.0);
    ((2.3283064365386963E-10 * x) | 0.0);
    var rHat = ((rlo - Math.imul(2147483647, lo$1)) | 0);
    if ((rHat < 0)) {
      var lo$2 = ((2147483647 + rHat) | 0);
      var absR_$_lo = lo$2;
      var absR_$_hi = 0;
    } else {
      var absR_$_lo = rHat;
      var absR_$_hi = 0;
    }
    if ((exp_$_hi < 0)) {
      var lo$3 = ((-absR_$_lo) | 0);
      var hi$3 = ((((-absR_$_hi) | 0) - ((lo$3 !== 0) | 0)) | 0);
      var x$2_$_lo = lo$3;
      var x$2_$_hi = hi$3;
    } else {
      var x$2_$_lo = absR_$_lo;
      var x$2_$_hi = absR_$_hi;
    }
    while (true) {
      var x$3_$_lo = longExp_$_lo;
      var x$3_$_hi = longExp_$_hi;
      if (((x$3_$_hi === 0) ? ((x$3_$_lo >>> 0) > 2147483647) : (x$3_$_hi > 0))) {
        res = res.dv(powerOfFive);
        var x$4_$_lo = longExp_$_lo;
        var x$4_$_hi = longExp_$_hi;
        var lo$4 = ((x$4_$_lo - 2147483647) | 0);
        var hi$4 = ((((x$4_$_hi - 1) | 0) + (((lo$4 >>> 0) < 2147483649) | 0)) | 0);
        longExp_$_lo = lo$4;
        longExp_$_hi = hi$4;
      } else {
        break;
      }
    }
    res = res.dv(this.iI.a[1].iu(x$2_$_lo));
    res = res.fZ(2147483647);
    var lo$5 = ((exp_$_lo - 2147483647) | 0);
    var hi$5 = ((((exp_$_hi - 1) | 0) + (((lo$5 >>> 0) < 2147483649) | 0)) | 0);
    longExp_$_lo = lo$5;
    longExp_$_hi = hi$5;
    while (true) {
      var x$5_$_lo = longExp_$_lo;
      var x$5_$_hi = longExp_$_hi;
      if (((x$5_$_hi === 0) ? ((x$5_$_lo >>> 0) > 2147483647) : (x$5_$_hi > 0))) {
        res = res.fZ(2147483647);
        var x$6_$_lo = longExp_$_lo;
        var x$6_$_hi = longExp_$_hi;
        var lo$6 = ((x$6_$_lo - 2147483647) | 0);
        var hi$6 = ((((x$6_$_hi - 1) | 0) + (((lo$6 >>> 0) < 2147483649) | 0)) | 0);
        longExp_$_lo = lo$6;
        longExp_$_hi = hi$6;
      } else {
        break;
      }
    }
    return res.fZ(x$2_$_lo);
  }
});
var $d_Ljava_math_Multiplication$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_math_Multiplication$, "java.math.Multiplication$", ({
  kE: 1
}));
export { $d_Ljava_math_Multiplication$ as $d_Ljava_math_Multiplication$ };
var $n_Ljava_math_Multiplication$;
function $m_Ljava_math_Multiplication$() {
  if ((!$n_Ljava_math_Multiplication$)) {
    $n_Ljava_math_Multiplication$ = new $c_Ljava_math_Multiplication$();
  }
  return $n_Ljava_math_Multiplication$;
}
export { $m_Ljava_math_Multiplication$ as $m_Ljava_math_Multiplication$ };
/** @constructor */
function $c_Ljava_math_BigInteger$() {
  this.lQ = null;
  this.gP = null;
  this.g7 = null;
  this.vi = null;
  this.IQ = null;
  this.zI = null;
  $n_Ljava_math_BigInteger$ = this;
  this.lQ = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 1);
  this.gP = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 10);
  this.g7 = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 0, 0);
  this.vi = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), (-1), 1);
  this.IQ = new ($d_Ljava_math_BigInteger.r().C)([this.g7, this.lQ, $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 2), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 3), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 4), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 5), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 6), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 7), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 8), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 9), this.gP]);
  var result = new ($d_Ljava_math_BigInteger.r().C)(32);
  var i = 0;
  while ((i < 32)) {
    var value = i;
    var $x_1 = $m_Ljava_math_BigInteger$();
    var lo = (((32 & value) === 0) ? (1 << value) : 0);
    var hi = (((32 & value) === 0) ? 0 : (1 << value));
    result.a[value] = $x_1.ed(lo, hi);
    i = ((1 + i) | 0);
  }
  this.zI = result;
}
export { $c_Ljava_math_BigInteger$ as $c_Ljava_math_BigInteger$ };
$p = $c_Ljava_math_BigInteger$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_math_BigInteger$;
/** @constructor */
function $h_Ljava_math_BigInteger$() {
}
export { $h_Ljava_math_BigInteger$ as $h_Ljava_math_BigInteger$ };
$h_Ljava_math_BigInteger$.prototype = $p;
$p.ed = (function(lVal_$_lo, lVal_$_hi) {
  if ((lVal_$_hi < 0)) {
    if ((((~lVal_$_lo) | (~lVal_$_hi)) !== 0)) {
      var lo = ((-lVal_$_lo) | 0);
      var hi = ((((-lVal_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
      return $ct_Ljava_math_BigInteger__I__J__(new $c_Ljava_math_BigInteger(), (-1), lo, hi);
    } else {
      return this.vi;
    }
  } else {
    return (((lVal_$_hi === 0) ? ((lVal_$_lo >>> 0) <= 10) : (lVal_$_hi < 0)) ? this.IQ.a[lVal_$_lo] : $ct_Ljava_math_BigInteger__I__J__(new $c_Ljava_math_BigInteger(), 1, lVal_$_lo, lVal_$_hi));
  }
});
$p.Pa = (function(exp) {
  if ((exp < this.zI.a.length)) {
    return this.zI.a[exp];
  } else {
    var intCount = (exp >> 5);
    var bitN = (31 & exp);
    var resDigits = new $j_java$002elang$002e$002dObject.$ac_I(((1 + intCount) | 0));
    resDigits.a[intCount] = (1 << bitN);
    return $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), 1, ((1 + intCount) | 0), resDigits);
  }
});
$p.SH = (function(byteLength) {
  if (((byteLength >>> 0) > 67108863)) {
    throw new $j_java$002elang$002e$002dObject.$c_jl_ArithmeticException("BigInteger would overflow supported range");
  }
});
var $d_Ljava_math_BigInteger$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_math_BigInteger$, "java.math.BigInteger$", ({
  ky: 1,
  a: 1
}));
export { $d_Ljava_math_BigInteger$ as $d_Ljava_math_BigInteger$ };
var $n_Ljava_math_BigInteger$;
function $m_Ljava_math_BigInteger$() {
  if ((!$n_Ljava_math_BigInteger$)) {
    $n_Ljava_math_BigInteger$ = new $c_Ljava_math_BigInteger$();
  }
  return $n_Ljava_math_BigInteger$;
}
export { $m_Ljava_math_BigInteger$ as $m_Ljava_math_BigInteger$ };
function $p_Ljava_math_BigInteger__setFromString__T__I__V($thiz, s, radix) {
  if ((((s === "") || (s === "+")) || (s === "-"))) {
    throw new $j_java$002elang$002e$002dObject.$c_jl_NumberFormatException("Zero length BigInteger");
  }
  var stringLength0 = s.length;
  if ((s.charCodeAt(0) === 45)) {
    var x1___1 = (-1);
    var x1___2 = 1;
    var x1___3 = ((stringLength0 - 1) | 0);
  } else if ((s.charCodeAt(0) === 43)) {
    var x1___1 = 1;
    var x1___2 = 1;
    var x1___3 = ((stringLength0 - 1) | 0);
  } else {
    var x1___1 = 1;
    var x1___2 = 0;
    var x1___3 = stringLength0;
  }
  var _sign = (x1___1 | 0);
  var startChar = (x1___2 | 0);
  var stringLength = (x1___3 | 0);
  var i = startChar;
  while ((i < stringLength0)) {
    var value = i;
    var c = s.charCodeAt(value);
    if (((c === 43) || (c === 45))) {
      throw new $j_java$002elang$002e$002dObject.$c_jl_NumberFormatException("Illegal embedded sign character");
    }
    i = ((1 + i) | 0);
  }
  var charsPerInt = $j_java$002emath$002e$002dConversion$0024.$m_Ljava_math_Conversion$().IS.a[radix];
  var bigRadixDigitsLength = ((stringLength / $j_java$002elang$002e$002dObject.$checkIntDivisor(charsPerInt)) | 0);
  var topChars = ((stringLength % $j_java$002elang$002e$002dObject.$checkIntDivisor(charsPerInt)) | 0);
  if ((topChars !== 0)) {
    bigRadixDigitsLength = ((1 + bigRadixDigitsLength) | 0);
  }
  var _digits = new $j_java$002elang$002e$002dObject.$ac_I(bigRadixDigitsLength);
  var bigRadix = $j_java$002emath$002e$002dConversion$0024.$m_Ljava_math_Conversion$().IR.a[((radix - 2) | 0)];
  var digitIndex = 0;
  var substrEnd = ((startChar + ((topChars === 0) ? charsPerInt : topChars)) | 0);
  var newDigit = 0;
  var substrStart = startChar;
  while ((substrStart < stringLength0)) {
    var this$4 = $j_java$002elang$002e$002dObject.$m_jl_Integer$();
    var beginIndex = substrStart;
    var endIndex = substrEnd;
    var s$1 = s.substring(beginIndex, endIndex);
    if (((((radix - 2) | 0) >>> 0) > 34)) {
      this$4.rd(s$1);
    }
    var bigRadixDigit = this$4.ez(s$1, radix, ((2147483648 / ($j_java$002elang$002e$002dObject.$checkIntDivisor(radix) >>> 0)) | 0));
    newDigit = $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I($m_Ljava_math_Multiplication$(), _digits, _digits, digitIndex, bigRadix);
    newDigit = ((newDigit + $m_Ljava_math_Elementary$().Vf(_digits, digitIndex, bigRadixDigit)) | 0);
    _digits.a[digitIndex] = newDigit;
    digitIndex = ((1 + digitIndex) | 0);
    substrStart = substrEnd;
    substrEnd = ((substrStart + charsPerInt) | 0);
  }
  $thiz.a3 = _sign;
  $thiz.a8 = digitIndex;
  $thiz.Y = _digits;
  $thiz.eS();
}
export { $p_Ljava_math_BigInteger__setFromString__T__I__V as $p_Ljava_math_BigInteger__setFromString__T__I__V };
function $ct_Ljava_math_BigInteger__($thiz) {
  $thiz.vh = (-2);
  $thiz.iH = 0;
  return $thiz;
}
export { $ct_Ljava_math_BigInteger__ as $ct_Ljava_math_BigInteger__ };
function $ct_Ljava_math_BigInteger__T__I__($thiz, s, radix) {
  $ct_Ljava_math_BigInteger__($thiz);
  if (((((radix - 2) | 0) >>> 0) > 34)) {
    throw new $j_java$002elang$002e$002dObject.$c_jl_NumberFormatException("Radix out of range");
  }
  if ((s === "")) {
    throw new $j_java$002elang$002e$002dObject.$c_jl_NumberFormatException("Zero length BigInteger");
  }
  $p_Ljava_math_BigInteger__setFromString__T__I__V($thiz, s, radix);
  return $thiz;
}
export { $ct_Ljava_math_BigInteger__T__I__ as $ct_Ljava_math_BigInteger__T__I__ };
function $ct_Ljava_math_BigInteger__T__($thiz, s) {
  $ct_Ljava_math_BigInteger__T__I__($thiz, s, 10);
  return $thiz;
}
export { $ct_Ljava_math_BigInteger__T__ as $ct_Ljava_math_BigInteger__T__ };
function $ct_Ljava_math_BigInteger__I__I__($thiz, sign, value) {
  $ct_Ljava_math_BigInteger__($thiz);
  $thiz.a3 = sign;
  $thiz.a8 = 1;
  $thiz.Y = new $j_java$002elang$002e$002dObject.$ac_I(new Int32Array([value]));
  return $thiz;
}
export { $ct_Ljava_math_BigInteger__I__I__ as $ct_Ljava_math_BigInteger__I__I__ };
function $ct_Ljava_math_BigInteger__I__AI__($thiz, signum, digits) {
  $ct_Ljava_math_BigInteger__($thiz);
  if ((digits.a.length === 0)) {
    $thiz.a3 = 0;
    $thiz.a8 = 1;
    $thiz.Y = new $j_java$002elang$002e$002dObject.$ac_I(new Int32Array([0]));
  } else {
    $thiz.a3 = signum;
    $thiz.a8 = digits.a.length;
    $thiz.Y = digits;
    $thiz.eS();
  }
  return $thiz;
}
export { $ct_Ljava_math_BigInteger__I__AI__ as $ct_Ljava_math_BigInteger__I__AI__ };
function $ct_Ljava_math_BigInteger__I__I__AI__($thiz, sign, numberLength, digits) {
  $ct_Ljava_math_BigInteger__($thiz);
  $thiz.a3 = sign;
  $thiz.a8 = numberLength;
  $thiz.Y = digits;
  return $thiz;
}
export { $ct_Ljava_math_BigInteger__I__I__AI__ as $ct_Ljava_math_BigInteger__I__I__AI__ };
function $ct_Ljava_math_BigInteger__I__J__($thiz, sign, lVal_$_lo, lVal_$_hi) {
  $ct_Ljava_math_BigInteger__($thiz);
  $thiz.a3 = sign;
  if ((lVal_$_hi === 0)) {
    $thiz.a8 = 1;
    $thiz.Y = new $j_java$002elang$002e$002dObject.$ac_I(new Int32Array([lVal_$_lo]));
  } else {
    $thiz.a8 = 2;
    $thiz.Y = new $j_java$002elang$002e$002dObject.$ac_I(new Int32Array([lVal_$_lo, lVal_$_hi]));
  }
  return $thiz;
}
export { $ct_Ljava_math_BigInteger__I__J__ as $ct_Ljava_math_BigInteger__I__J__ };
/** @constructor */
function $c_Ljava_math_BigInteger() {
  this.Y = null;
  this.a8 = 0;
  this.a3 = 0;
  this.vh = 0;
  this.iH = 0;
}
export { $c_Ljava_math_BigInteger as $c_Ljava_math_BigInteger };
$p = $c_Ljava_math_BigInteger.prototype = new $j_java$002elang$002e$002dObject.$h_jl_Number();
$p.constructor = $c_Ljava_math_BigInteger;
/** @constructor */
function $h_Ljava_math_BigInteger() {
}
export { $h_Ljava_math_BigInteger as $h_Ljava_math_BigInteger };
$h_Ljava_math_BigInteger.prototype = $p;
$p.NO = (function() {
  return ((this.a3 < 0) ? $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), 1, this.a8, this.Y) : this);
});
$p.jl = (function(bi) {
  return ((this.a3 > bi.a3) ? 1 : ((this.a3 < bi.a3) ? (-1) : ((this.a8 > bi.a8) ? this.a3 : ((this.a8 < bi.a8) ? ((-bi.a3) | 0) : Math.imul(this.a3, $m_Ljava_math_Elementary$().u3(this.Y, bi.Y, this.a8))))));
});
$p.TB = (function(divisor) {
  if ((divisor.a3 === 0)) {
    throw new $j_java$002elang$002e$002dObject.$c_jl_ArithmeticException("BigInteger divide by zero");
  }
  var divisorSign = divisor.a3;
  if (divisor.Vs()) {
    return ((divisor.a3 > 0) ? this : this.xI());
  } else {
    var thisSign = this.a3;
    var thisLen = this.a8;
    var divisorLen = divisor.a8;
    if ((((thisLen + divisorLen) | 0) === 2)) {
      var dividend = this.Y.a[0];
      var divisor$1 = divisor.Y.a[0];
      var x = (((dividend >>> 0) / ($j_java$002elang$002e$002dObject.$checkIntDivisor(divisor$1) >>> 0)) | 0);
      if ((thisSign !== divisorSign)) {
        var lo = ((-x) | 0);
        var hi = ((-((lo !== 0) | 0)) | 0);
        var bi_$_lo = lo;
        var bi_$_hi = hi;
      } else {
        var bi_$_lo = x;
        var bi_$_hi = 0;
      }
      return $m_Ljava_math_BigInteger$().ed(bi_$_lo, bi_$_hi);
    } else {
      var cmp = ((thisLen !== divisorLen) ? ((thisLen > divisorLen) ? 1 : (-1)) : $m_Ljava_math_Elementary$().u3(this.Y, divisor.Y, thisLen));
      if ((cmp === 0)) {
        return ((thisSign === divisorSign) ? $m_Ljava_math_BigInteger$().lQ : $m_Ljava_math_BigInteger$().vi);
      } else if ((cmp === (-1))) {
        return $m_Ljava_math_BigInteger$().g7;
      } else {
        var resLength = ((1 + ((thisLen - divisorLen) | 0)) | 0);
        var resDigits = new $j_java$002elang$002e$002dObject.$ac_I(resLength);
        var resSign = ((thisSign === divisorSign) ? 1 : (-1));
        if ((divisorLen === 1)) {
          $m_Ljava_math_Division$().OJ(resDigits, this.Y, thisLen, divisor.Y.a[0]);
        } else {
          $m_Ljava_math_Division$().OI(resDigits, resLength, this.Y, thisLen, divisor.Y, divisorLen);
        }
        var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resLength, resDigits);
        result.eS();
        return result;
      }
    }
  }
});
$p.TC = (function(divisor) {
  return this.Bl(divisor).Y3();
});
$p.Bl = (function(divisor) {
  var divisorSign = divisor.a3;
  if ((divisorSign === 0)) {
    throw new $j_java$002elang$002e$002dObject.$c_jl_ArithmeticException("BigInteger divide by zero");
  }
  var divisorLen = divisor.a8;
  var divisorDigits = divisor.Y;
  if ((divisorLen === 1)) {
    return $m_Ljava_math_Division$().TD(this, divisorDigits.a[0], divisorSign);
  } else {
    var thisDigits = this.Y;
    var thisLen = this.a8;
    if ((((thisLen !== divisorLen) ? ((thisLen > divisorLen) ? 1 : (-1)) : $m_Ljava_math_Elementary$().u3(thisDigits, divisorDigits, thisLen)) < 0)) {
      return new $c_Ljava_math_BigInteger$QuotAndRem($m_Ljava_math_BigInteger$().g7, this);
    } else {
      var thisSign = this.a3;
      var quotientLength = ((1 + ((thisLen - divisorLen) | 0)) | 0);
      var quotientSign = ((thisSign === divisorSign) ? 1 : (-1));
      var quotientDigits = new $j_java$002elang$002e$002dObject.$ac_I(quotientLength);
      var remainderDigits = $m_Ljava_math_Division$().OI(quotientDigits, quotientLength, thisDigits, thisLen, divisorDigits, divisorLen);
      var result0 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), quotientSign, quotientLength, quotientDigits);
      var result1 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), thisSign, divisorLen, remainderDigits);
      result0.eS();
      result1.eS();
      return new $c_Ljava_math_BigInteger$QuotAndRem(result0, result1);
    }
  }
});
$p.f = (function(x) {
  return ((x instanceof $c_Ljava_math_BigInteger) && (((this.a3 === x.a3) && (this.a8 === x.a8)) && this.TP(x.Y)));
});
$p.P8 = (function() {
  if ((this.a3 === 0)) {
    return (-1);
  } else {
    var i = this.xn();
    var i$1 = this.Y.a[i];
    return (((i << 5) + ((32 - Math.clz32(((~i$1) & ((i$1 - 1) | 0)))) | 0)) | 0);
  }
});
$p.m = (function() {
  if ((this.iH !== 0)) {
    return this.iH;
  } else {
    var end = this.a8;
    var i = 0;
    while ((i < end)) {
      var value = i;
      this.iH = ((Math.imul(33, this.iH) + this.Y.a[value]) | 0);
      i = ((1 + i) | 0);
    }
    this.iH = Math.imul(this.iH, this.a3);
    return this.iH;
  }
});
$p.r5 = (function() {
  return Math.imul(this.a3, this.Y.a[0]);
});
$p.gB = (function() {
  if ((this.a8 > 1)) {
    var value = this.Y.a[1];
    var value$1 = this.Y.a[0];
    var value$3_$_lo = value$1;
    var value$3_$_hi = value;
  } else {
    var value$2 = this.Y.a[0];
    var value$3_$_lo = value$2;
    var value$3_$_hi = 0;
  }
  var value$4 = this.a3;
  var hi$3 = (value$4 >> 31);
  var a0 = (65535 & value$4);
  var a1 = ((value$4 >>> 16) | 0);
  var b0 = (65535 & value$3_$_lo);
  var b1 = ((value$3_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$4 = ((((((((Math.imul(value$4, value$3_$_hi) + Math.imul(hi$3, value$3_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  return $j_java$002elang$002e$002dObject.$bL(lo, hi$4);
});
$p.dv = (function(bi) {
  return (((bi.a3 === 0) || (this.a3 === 0)) ? $m_Ljava_math_BigInteger$().g7 : $m_Ljava_math_Multiplication$().xA(this, bi));
});
$p.xI = (function() {
  return ((this.a3 === 0) ? this : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), ((-this.a3) | 0), this.a8, this.Y));
});
$p.iu = (function(exp) {
  if ((exp < 0)) {
    throw new $j_java$002elang$002e$002dObject.$c_jl_ArithmeticException("Negative exponent");
  } else if ((exp === 0)) {
    return $m_Ljava_math_BigInteger$().lQ;
  } else if ((((exp === 1) || this.f($m_Ljava_math_BigInteger$().lQ)) || this.f($m_Ljava_math_BigInteger$().g7))) {
    return this;
  } else if ((!this.ya(0))) {
    var x = 1;
    while ((!this.ya(x))) {
      x = ((1 + x) | 0);
    }
    return $m_Ljava_math_BigInteger$().Pa(Math.imul(x, exp)).dv(this.y9(x).iu(exp));
  } else {
    return $m_Ljava_math_Multiplication$().WF(this, exp);
  }
});
$p.fZ = (function(n) {
  return (((n === 0) || (this.a3 === 0)) ? this : ((n > 0) ? $m_Ljava_math_BitLevel$().Qq(this, n) : $m_Ljava_math_BitLevel$().Qs(this, ((-n) | 0))));
});
$p.y9 = (function(n) {
  return (((n === 0) || (this.a3 === 0)) ? this : ((n > 0) ? $m_Ljava_math_BitLevel$().Qs(this, n) : $m_Ljava_math_BitLevel$().Qq(this, ((-n) | 0))));
});
$p.ya = (function(n) {
  var intCount = (n >> 5);
  if ((n === 0)) {
    return ((1 & this.Y.a[0]) !== 0);
  } else {
    if ((n < 0)) {
      throw new $j_java$002elang$002e$002dObject.$c_jl_ArithmeticException("Negative bit address");
    }
    if ((intCount >= this.a8)) {
      return (this.a3 < 0);
    } else if ((!((this.a3 < 0) && (intCount < this.xn())))) {
      var digit = this.Y.a[intCount];
      if ((this.a3 < 0)) {
        digit = ((this.xn() === intCount) ? ((-digit) | 0) : (~digit));
      }
      return ((digit & (1 << n)) !== 0);
    } else {
      return false;
    }
  }
});
$p.b = (function() {
  return $j_java$002emath$002e$002dConversion$0024.$m_Ljava_math_Conversion$().rp(this);
});
$p.eS = (function() {
  while (true) {
    if ((this.a8 > 0)) {
      this.a8 = ((this.a8 - 1) | 0);
      if ((this.Y.a[this.a8] === 0)) {
        continue;
      }
    }
    break;
  }
  if ((this.Y.a[this.a8] === 0)) {
    this.a3 = 0;
  }
  this.a8 = ((1 + this.a8) | 0);
});
$p.TP = (function(b) {
  var i = 0;
  while ((i !== this.a8)) {
    if ((this.Y.a[i] !== b.a[i])) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$p.xn = (function() {
  if ((this.vh === (-2))) {
    if ((this.a3 === 0)) {
      var $x_1 = (-1);
    } else {
      var i = 0;
      while ((this.Y.a[i] === 0)) {
        i = ((1 + i) | 0);
      }
      var $x_1 = i;
    }
    this.vh = $x_1;
  }
  return this.vh;
});
$p.Vs = (function() {
  return ((this.a8 === 1) && (this.Y.a[0] === 1));
});
$p.XC = (function() {
  return ((this.a3 === 0) ? this : $m_Ljava_math_BitLevel$().XB(this));
});
$p.fh = (function(o) {
  return this.jl(o);
});
function $isArrayOf_Ljava_math_BigInteger(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.du)));
}
export { $isArrayOf_Ljava_math_BigInteger as $isArrayOf_Ljava_math_BigInteger };
var $d_Ljava_math_BigInteger = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_math_BigInteger, "java.math.BigInteger", ({
  du: 1,
  aA: 1,
  a: 1,
  j: 1
}));
export { $d_Ljava_math_BigInteger as $d_Ljava_math_BigInteger };
